import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import DownloadLinkGenerator from "./components/DownloadLinkGenerator";
// import Countdown from "./components/Countdown";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Hero from "./components/Hero";
// function About() {
//   return  <h1>About Us</h1>
// }

function App() {
  return (
    <Router>
      <Navbar/>
       <Routes>
         <Route path="/" element={<Hero />} />
         <Route path="/Download" element={<DownloadLinkGenerator />} />
         <Route path="/About" element={<About/>}/>
         <Route path="/Contact" element={<Contact/>}/>
       </Routes>
     </Router>
  );
}

export default App;
